import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import React, { ReactNode } from 'react';

import classNames from 'classnames';
import { useParseBreakpoint } from '../hooks/hook';
import mock from './InspectionBanner.mock';
import useStyle from './InspectionBanner.style';

interface Props {
  headline?: ReactNode;
  mainText?: ReactNode;
  img?: string;
  mobileImg?: string;
  benefitList?: { id: number; logo: string; title: string; smallTitle: string; bodyText: string }[];
}

const InspectionBanner: React.FC<Props> = ({ headline, mainText, img, mobileImg, benefitList = [] }) => {
  const classes = useStyle();
  const bp = useParseBreakpoint();

  const mainContent = (
    <Box className={classNames(classes.mainContent, 'header-transparent', 'header-homepage')}>
      <Typography
        data-testid="INSPECTION_BANNER_HEADLINE"
        variant={bp({
          xs: 'h3',
          md: 'h3',
          xl: 'h2',
          xxl: 'h1',
        })}
        className={classes.mainContentHead}
      >
        <>{headline}</>
      </Typography>
      <Typography
        variant={bp({
          xs: 'h6',
          md: 'body1',
          xl: 'h6',
          xxl: 'h5',
        })}
        className={classes.mainContentText}
      >
        <>{mainText}</>
      </Typography>
      <img
        src={bp({
          xs: mobileImg,
          md: img,
        })}
        alt="mainImage"
        className={classes.mainImg}
      />
    </Box>
  );

  const benefitWrapper = (
    <Box className={classes.benefitWrapper}>
      {benefitList.map((item: any) => {
        const { id, logo, title, smallTitle, bodyText } = item;
        return (
          <Box key={id} className={classes.benefitItem}>
            <Box key={id} className={classes.contentItem}>
              <div className={classes.imgItemWrapper}>
                <img src={logo} alt="logo" />
              </div>
              <Typography variant="h6" className={classes.titleItem}>
                {title}
              </Typography>
              <Typography variant="h6" className={classes.smallTitleItem}>
                {smallTitle}
              </Typography>
              <Typography variant="body1">{bodyText}</Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );

  return (
    <>
      <div className={classes.root}>
        <Grid container className={classes.container}>
          <Grid item xs={12} md={12} className={classes.mainWrapper}>
            {mainContent}
          </Grid>
          <Grid item container xs={12}>
            {benefitWrapper}
          </Grid>
        </Grid>
      </div>
    </>
  );
};

InspectionBanner.defaultProps = mock;

export default InspectionBanner;
